import type { FlipTextItem } from "@swiggy-private/cart-types";

/**
 * Replaces placeholder {item_discount_percentage} in flip_text with the item's discount percentage.
 * Used for Magic Items so one widget-level template can show per-item values.
 */
export function resolveFlipTextWithItemValues(
    flipText: FlipTextItem[] | undefined,
    itemDiscountPercentage: number | undefined,
): FlipTextItem[] {
    if (!flipText?.length) return [];
    const value = itemDiscountPercentage != null ? String(itemDiscountPercentage) : "";
    return flipText.map((item) => ({
        ...item,
        text: item.text.replace(/\{item_discount_percentage\}/g, value),
    }));
}

// Adds hyphenation to the first word of item name
// after 6 characters
export const addWordBreaks = (name: string, isPopCart = false) => {
    const maxLength = isPopCart ? 9 : 6;
    const words = name.split(" ");
    let newWords: string[] = [];
    const word = words[0];
    if (word.length > maxLength) {
        let firstWord = word.slice(0, maxLength);
        firstWord += "&thinsp;-<br/>";

        const endWord = word.slice(maxLength);
        newWords = [...[firstWord, endWord], ...words.slice(1)];
    } else {
        newWords = words;
    }
    return newWords.join(" ");
};
